export default "__VITE_ASSET__ClpWwHrM__"